import React from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./review.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";

const StudentReview = () => {
  const TeamData = [
    {
      name: "Zahid Hasan",
      des: "Engaging course, knowledgeable professor, highly recommend!",
      id: 1,
    },
    {
      name: "Sanjida Akter",
      des: "Challenging yet rewarding, supportive instructor, valuable feedback",
      id: 2,
    },
    {
      name: "Md Rakibul Islam",
      des: "Comprehensive material, passionate professor, heavy workload.",
      id: 3,
    },
    {
      name: "Iftakher Ahmed",
      des: "Active participation, collaborative learning, lacking practical application.",
      id: 4,
    },
    {
      name: "Aysha Akter",
      des: "Well-structured, clear explanations, would benefit from more interaction. ",
      id: 5,
    },
  ];
  return (
    <div>
      {" "}
      <section className="team_container">
        <div data-aos="fade-up" className="team_slider  my-10 py-5 ">
          <div className="conent-aria text-center pt-5">
            <h1 className="text-[#0D1C37] pt-5 font-bold text-3xl mt-4 uppercase">
              Our COURSE REVIEW
            </h1>
          </div>
          <div className="  custom_container mx-auto py-10 px-5 ">
            <Swiper
              slidesPerView={3}
              spaceBetween={25}
              slidesPerGroup={3}
              loop={true}
              centerslide={"true"}
              fade={"true"}
              grabCursor={"true"}
              pagination={{
                dynamicBullets: true,
              }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              modules={[Pagination, Autoplay]}
              className="mySwiper"
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                520: {
                  slidesPerView: 2,
                },
                950: {
                  slidesPerView: 3,
                },
              }}
            >
              {TeamData.map((team) => (
                <SwiperSlide key={team?.id}>
                  <div className="team_member w-[320px] mb-10">
                    <div className="img_content">
                      <span className="overlay"></span>
                      <div className="team_member_img">
                        <img
                          src="https://www.citypng.com/public/uploads/preview/png-round-blue-contact-user-profile-icon-11639786938sxvzj5ogua.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="team-content">
                      <h2 className="name">{team?.name}</h2>
                      <p className="description">{team.des}</p>

                      {/* <button  className="button">View More</button> */}
                      <div className="social_icon">
                        {team.id === 3 ? (
                          <>
                            {" "}
                            <i className="fa-sharp fa-solid fa-star"></i>
                            <i className="fa-sharp fa-solid fa-star"></i>
                            <i className="fa-sharp fa-solid fa-star"></i>
                            <i className="fa-sharp fa-solid fa-star"></i>
                            <i className="fa-solid fa-star-half-stroke"></i>
                          </>
                        ) : team.id === 5 ? (
                          <>
                            {" "}
                            <i className="fa-sharp fa-solid fa-star"></i>
                            <i className="fa-sharp fa-solid fa-star"></i>
                            <i className="fa-sharp fa-solid fa-star"></i>
                            <i className="fa-sharp fa-solid fa-star"></i>
                            <i className="fa-solid fa-star-half-stroke"></i>
                          </>
                        ) : (
                          <>
                            {" "}
                            <i className="fa-sharp fa-solid fa-star"></i>
                            <i className="fa-sharp fa-solid fa-star"></i>
                            <i className="fa-sharp fa-solid fa-star"></i>
                            <i className="fa-sharp fa-solid fa-star"></i>
                            <i className="fa-sharp fa-solid fa-star"></i>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StudentReview;
